module.exports = __webpack_public_path__ + "static/media/shoes01.757a76fc.png";